import merge from "lodash/merge";
import { CandlestickSeriesOptions, ChartCandle } from "../chart.typings";
import BaseChartSeries from "./baseSeries";
import { candleSeriesOptions } from "../../../assets/constants";

class CandleStickSeries extends BaseChartSeries<ChartCandle, CandlestickSeriesOptions> {

    addSeriesToChart() {
        return this.chart.chartApi.addCandlestickSeries(this.seriesOptions)
    }

    getDefaultOptions(): CandlestickSeriesOptions {
        return merge(candleSeriesOptions, this.options)
    }
}

export default CandleStickSeries;